import classNames from 'classnames'

export default function BracketSet({ id, identifier, round, totalGames, slots, registerBoxRef, registerSlotRef }) {
	function isWinner(totalGames, score) {
		return score > totalGames / 2
	}

	return (
		<div ref={(el) => registerBoxRef?.(id, el)} className={`relative mx-3 bracketSet bracketIdentifier_${identifier} text-white`}>
			{slots.map((slot, slotIndex) => (
				<div ref={(el) => registerSlotRef?.(id, slotIndex, el)} className="flex flex-row min-w-36 max-w-[164px] border border-gray-700 bg-[#242424]">
					<div className={classNames(isWinner(totalGames, slot.entrant.score) && 'font-bold', 'h-6 w-36 overflow-hidden text-ellipsis whitespace-nowrap')}>
						{slot.entrant.name}
					</div>
					<div className={classNames('h-6 w-6 text-center float-right bg-neutral-700 font-bold')}>{slot.entrant.score}</div>
				</div>
			))}
			<div className="absolute w-4 h-6 top-3 -left-4 bg-[#242424] border text-center border-gray-700">{identifier}</div>
		</div>
	)
}
